const Landing = () => {
  const directToGooglePlay = () =>
    (window.location.href = process.env.REACT_APP_PLAYSTORE_URI);

  const directToAppStore = () =>
    (window.location.href = process.env.REACT_APP_APPSTORE_URI);

  return (
    <section className="y-section--top y-landing-section">
      <div className="container mt-12 gap-10 lg:mt-0 lg:grid lg:grid-cols-2 lg:gap-x-10 lg:items-center">
        {/* Landing text */}
        <div className="justify-center lg:justify-start">
          <h1 className="text-center lg:text-left y-heading--one mb-9">
            Service at your Doorsteps
          </h1>
          <p className="y-body--large text-center lg:text-left mx-auto lg:mx-0 y-text--dark-gray max-w-lg">
            Hire experts through YANTRA and get your services done at your
            doorstep.
          </p>

          <div className="flex gap-x-6 mt-14 flex-wrap justify-center lg:justify-start">
            <button
              className="y-btn--icon-primary  mb-4"
              onClick={directToGooglePlay}
            >
              <svg className="y-btn__icon" viewBox="0 0 28.9 32">
                <path
                  d="M0.1,0C0,0.1,0,0.2,0,0.4v31c0,0.3,0.1,0.5,0.2,0.6l15.2-16.1L0.1,0z M16.5,16.9l3.9,4.1l-5.6,3.2
	c0,0-7.1,4.1-11.1,6.3C3.7,30.5,16.5,16.9,16.5,16.9z M17.6,15.8l4.2,4.4c0.7-0.4,5.8-3.3,6.6-3.7c0.8-0.5,0.7-1.1,0-1.4
	c-0.6-0.3-5.8-3.3-6.6-3.8L17.6,15.8C17.6,15.8,17.6,15.8,17.6,15.8z M16.5,14.8l4-4.2l-5.7-3.2c0,0-9.3-5.3-12.3-7.1L16.5,14.8
	C16.5,14.8,16.5,14.8,16.5,14.8z"
                />
              </svg>

              <span>Get on Google play</span>
            </button>

            <button className="y-btn--icon-primary" onClick={directToAppStore}>
              <svg
                className="y-btn__icon large"
                viewBox="0 0 27 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21.8393 30.0986C20.1549 31.7196 18.2965 31.4669 16.5251 30.7026C14.6418 29.9229 12.9202 29.8736 10.9312 30.7026C8.4544 31.7628 7.13985 31.4546 5.64815 30.0986C-2.7737 21.5002 -1.53063 8.40222 8.04108 7.90912C10.3625 8.0324 11.9879 9.18194 13.3552 9.27747C15.3877 8.86759 17.3331 7.69339 19.5085 7.84749C22.1221 8.05705 24.0768 9.08023 25.382 10.9201C20.0057 14.1253 21.2799 21.1519 26.218 23.1243C25.2298 25.6977 23.9618 28.2402 21.8361 30.1202L21.8393 30.0986ZM13.1688 7.81667C12.9171 3.99515 16.0403 0.851644 19.6328 0.543457C20.1269 4.95053 15.5928 8.24813 13.1688 7.81667Z"
                  fill="white"
                />
              </svg>

              <div className="flex flex-col">
                <span>Get on App store </span>
              </div>
            </button>
          </div>
        </div>
        {/* Landing images */}
        <div className="flex justify-center lg:justify-end">
          <figure className="y-landing-image mt-10 lg-mt-0">
            <img src="/images/landing-img.webp" alt="" />
          </figure>
        </div>
      </div>
    </section>
  );
};

export default Landing;
